import { Country, IsoCode } from '@dreryk/address-common-api';
import { NationalIdentificationNumberCountry } from '@dreryk/personal-external-identifier-common-api';

import { getCurrentLocale } from '@dreryk/react-common';
import { KeyExtractorRendererKeyExtractor, SelectFilterCreator } from '@dreryk/react-components';

export const countrySelectFilterCreator: SelectFilterCreator<Country> = ({ includes }) => (country) =>
   includes(country.getName(getCurrentLocale()));

export const countryKeyExtractor: KeyExtractorRendererKeyExtractor<Country> = (country): IsoCode =>
   country.getIsoCode();

export const nationalIdentificationNumberCountryIsoCodeGetter = (
   country: NationalIdentificationNumberCountry
): IsoCode => country.getValue().getIsoCode();

export const getCountryDisplayValue = (country?: Country): string =>
   country ? country.getName(getCurrentLocale()) : '';
